module.exports = function() {
  return new Worker(__webpack_public_path__ + "86d86f2196b93740828d.worker.js");
};